import { createIcon } from './_icon';

const CheckAllIcon = createIcon([
	[
		'M.41 13.41 6 19l1.41-1.42L1.83 12m20.41-6.42L11.66 16.17 7.5 12l-1.43 1.41L11.66 19l12-12M18 7l-1.41-1.42-6.35 6.35 1.42 1.41L18 7Z',
	],
]);

export default CheckAllIcon;
